// Generated with tools/create-component.js
import React, { useEffect } from "react";
import { CmsContent, Image } from "components";
import { HeroQueryFragment } from "codegen";
import "./Hero.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import classNames from "classnames";

interface HeroProps {
  data: HeroQueryFragment;
  location?: any;
}

export const Hero: React.FC<HeroProps> = ({ data: { image, content, eyebrow, compact } }) => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <>
      <section
        className={classNames({
          hero: true,
          "layout--medium": true,
          "hero--compact": compact,
          "hero--colour": !image,
        })}
      >
        <div className="hero__wrapper">
          <div>
            {eyebrow && (
              <span className="eyebrow" data-aos="fade-right">
                {eyebrow}
              </span>
            )}
            {content && (
              <div data-aos="fade-right">
                <CmsContent content={content} />
              </div>
            )}
          </div>
          <div>{image && <Image src={image} className="hero__background" />}</div>
        </div>
        {!compact && image && (
          <span className="hero__wrapper--cta" data-aos="fade-down">
            Scroll Down
          </span>
        )}
      </section>
    </>
  );
};
